<script>
  import { createEventDispatcher } from "svelte";

  export let otpCode = "";
  const dispatch = createEventDispatcher();

  let enteredOtp = "";

  function handleSubmit() {
    if (enteredOtp) {
      dispatch("submit", enteredOtp);
    }
  }

  function handleCancel() {
    dispatch("cancel");
  }
</script>

<div class="otp-card">
  <h2>Enter OTP to Disable 2FA</h2>
  <input type="text" bind:value={enteredOtp} placeholder="Enter OTP" />
  <div class="buttons">
    <button on:click={handleCancel}>Cancel</button>
    <button on:click={handleSubmit}>Submit</button>
  </div>
</div>

<style>
  .otp-card {
    position: fixed;
    top: 60%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 20px;
    background: white;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    text-align: center;
    z-index: 1000;
  }

  .otp-card input {
    width: 80%;
    padding: 10px;
    margin: 10px 0;
    border: 1px solid #ccc;
    border-radius: 4px;
  }

  .otp-card .buttons {
    display: flex;
    justify-content: space-around;
  }

  .otp-card button {
    padding: 10px 20px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }

  .otp-card button:first-child {
    background-color: #f44336;
    color: white;
  }

  .otp-card button:last-child {
    background-color: #4caf50;
    color: white;
  }

  @media (max-width: 768px) {
    .otp-card {
      width: 80%;
    }

    .otp-card input {
      width: 100%;
    }

    .otp-card .buttons {
      flex-direction: column;
    }

    .otp-card .buttons button {
      width: 100%;
      margin-top: 10px;
    }
  }
</style>
